import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ToolTip from "../../components/component-tools/ToolTip";
import { CloseOrderType } from "../../interfaces/order";
import { getDataForCloseOrderTable } from "../../services/orderService";
import { formatDate } from "../../services/helpers";

const CloseOrder = () => {
  const [loading, setLoading] = useState(true);
  const [loadingSpinner, setLoadingSpinner] = useState(false);
  const [orders, setOrders] = useState<CloseOrderType[] | null>([]);
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const [showNotesModal, setShowNotesModal] = useState(false);

  useEffect(() => {
    const fetchCloseOrdersData = async () => {
      try {
        setLoading(true);
        const ordersResponse = await getDataForCloseOrderTable();

        setOrders(ordersResponse);
      } catch {
        console.log("error fetching orders");
      } finally {
        setLoading(false);
      }
    };
    fetchCloseOrdersData();
  }, []);

  // not used anymore
  // const handleGenerateCloseFileReport = async () => {
  //   try {
  //     setLoadingSpinner(true);
  //     const response = await generateCloseFileReport();
  //     if (!response) throw new Error("No response from server");

  //     const blob = await response.blob();
  //     const url = window.URL.createObjectURL(blob);
  //     const a = document.createElement("a");
  //     a.href = url;
  //     const today = new Date();
  //     const formattedDate = `${
  //       today.getMonth() + 1
  //     }-${today.getDate()}-${today.getFullYear()}`;
  //     const fileName = `Close_File_Report_${formattedDate}.pdf`;

  //     a.download = fileName;
  //     document.body.appendChild(a);
  //     a.click();
  //     document.body.removeChild(a);
  //     return true;
  //   } catch (error) {
  //     console.error("Error generating report:", error);
  //     setErrorMessage("Error generating close file report.");
  //   } finally {
  //     setLoadingSpinner(false);
  //   }
  // };

  return (
    <div className="content-container">
      <div className="header-container">
        <h1 style={{ display: "flex" }}>
          Close Order
          <div
            onClick={() => setShowNotesModal(true)}
            style={{ cursor: "pointer", display: "flex" }}
          >
            <ToolTip
              tooltipText="Click to view details about this table"
              placement="right"
              className="info-icon"
            />
          </div>
        </h1>
        {/* <div className="page-items-container">
          <button
            className="oxbtn btn-grey"
            onClick={() => handleGenerateCloseFileReport()}
          >
            Generate Report
          </button>
        </div> */}
      </div>

      {showNotesModal && (
        <div className="modal-mask">
          <div className="modal-content">
            <ul style={{ marginTop: "10px", paddingLeft: "20px" }}>
              <li>
                This table shows all orders (that are not already closed or
                deleted and have a candidate forms received date of null or
                greater than 7/13/25) that are ready to send a final report or
                to close. This includes:
              </li>
              <ul>
                <li>
                  Reference Final Report Ready
                  <ul>
                    <li>Reference Orders that have no Final Report date</li>
                    <li>
                      <b>All</b> associated References have a Letter Returned
                      date <b>after</b> the migration cutoff (July 13, 2025)
                    </li>
                  </ul>
                </li>
                <li>
                  Criminal Final Report Ready
                  <ul>
                    <li>Criminal Orders that have no Final Report date</li>
                    <li>
                      <b>All</b> associated Criminal Details/Services either
                      have a Received date or are marked as In-Active. (Fama and
                      Subscription Add-Ons must be Admin Reviewed first)
                    </li>
                  </ul>
                </li>
                <li>
                  Reference Follow up Expired (No Response){" "}
                  <ul>
                    <li>Reference Orders that have no Final Report date</li>
                    <li>
                      At least one Reference was sent their first letter more
                      than 28 days ago, and <b>no</b> Returned date has been
                      recorded
                    </li>
                  </ul>
                </li>
                <li>
                  Update the Final Report{" "}
                  <ul>
                    <li>
                      Reference Orders that need the final report to be re-sent
                      because a reference response was received after the
                      initial send.
                    </li>
                  </ul>
                </li>
                <li>
                  Notify Client (Subscription)
                  <ul>
                    <li>
                      Any Criminal Orders (
                      <b>including orders with final reports sent</b>) that have
                      an active criminal detail that is a subscription add-on
                      that has a received date but the client has not been
                      notified.
                    </li>
                  </ul>
                </li>
              </ul>
            </ul>
            <div>
              <button
                className="smbtn btn-red"
                onClick={() => setShowNotesModal(false)}
                style={{ marginBottom: "15px" }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {loading ? (
        <div className="loading-divider">
          <div className="loading-bar"></div>
        </div>
      ) : (
        <>
          <div className="divider"></div>
          <div className="table-wrapper">
            <div className="table-container">
              <table className="table" style={{ cursor: "pointer" }}>
                <thead>
                  <tr>
                    <th style={{ width: "80px" }}>OrderID</th>
                    <th style={{ width: "300px" }}>Client Name Merge Field</th>
                    <th style={{ width: "200px" }}>Candidate Name</th>
                    <th style={{ width: "40px" }}></th>
                    <th style={{ width: "40px" }}></th>
                    <th style={{ width: "40px" }}></th>
                    <th style={{ width: "200px" }}>Closure Reason</th>
                    <th style={{ width: "40px" }}></th>
                  </tr>
                </thead>
                <tbody>
                  {orders?.length === 0 ? (
                    <tr>
                      <td colSpan={6} style={{ textAlign: "center" }}>
                        No orders to close.
                      </td>
                    </tr>
                  ) : (
                    orders?.map((order, index) => {
                      return (
                        <tr
                          key={index}
                          onClick={() =>
                            navigate(`/admin/view-order/${order.orderID}`)
                          }
                        >
                          <td>{order.orderID}</td>
                          <td>{order.clientName}</td>
                          <td>{order.candidateName}</td>
                          <td>
                            {order?.alert?.trim() && (
                              <ToolTip
                                tooltipText={`${order.alert}\n${formatDate(order?.alertLastUpdatedDate, "datetime")}`}
                                placement="bottom"
                                className="alert-sticky"
                              >
                                <i className="bi bi-stickies-fill"></i>
                              </ToolTip>
                            )}
                          </td>
                          <td>
                            {order.referenceDetailRedFlag && (
                              <div className="orange-flag">
                                <i className="bi bi-flag-fill"></i>
                              </div>
                            )}
                          </td>
                          <td>
                            {order.criminalDetailRedFlag && (
                              <div className="blue-flag">
                                <i className="bi bi-flag-fill"></i>
                              </div>
                            )}
                          </td>
                          <td>
                            <span
                              className={
                                order.closureReason ===
                                "Criminal Final Report Ready"
                                  ? "badge blue-chip"
                                  : order.closureReason ===
                                      "Reference Final Report Ready"
                                    ? "badge orange-chip"
                                    : order.closureReason ===
                                        "Update the Final Report"
                                      ? "badge green-chip"
                                      : order.closureReason ===
                                          "Notify Client (Subscription)"
                                        ? "badge red-chip"
                                        : "badge purple-chip"
                              }
                            >
                              {order.closureReason}
                            </span>
                          </td>
                          <td>
                            <div
                              onClick={(e) => {
                                e.stopPropagation();
                                navigate(`/admin/orders/all`, {
                                  state: { initialSearch: order.candidateName },
                                });
                              }}
                            >
                              <i className="bi bi-search search-icon"></i>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
      {errorMessage && (
        <div
          className="alert-message alert alert-danger alert-dismissible fade show"
          role="alert"
        >
          {errorMessage}
          <button
            type="button"
            className="btn-close"
            onClick={() => setErrorMessage("")}
            aria-label="Close"
          ></button>
        </div>
      )}
      {loadingSpinner && (
        <div className="loading-mask">
          <div className="loading-spinner"></div>
        </div>
      )}
    </div>
  );
};

export default CloseOrder;
